export default __webpack_public_path__ + "static/media/Bionic-Arm-05.89f0a56b.jpg";